import { render } from "./VeteranCardInformation.vue?vue&type=template&id=c5f412f0&scoped=true"
import script from "./VeteranCardInformation.vue?vue&type=script&lang=js"
export * from "./VeteranCardInformation.vue?vue&type=script&lang=js"

import "./VeteranCardInformation.vue?vue&type=style&index=0&id=c5f412f0&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c5f412f0"]])

export default __exports__